import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldFooter } from '../FieldFooter/FieldFooter';
import { Legend, Wrapper } from './RadioGroup.styles';
export const RadioGroup = ({ children, errorMessage, label, ...wrapperProps })=>/*#__PURE__*/ _jsxs(Wrapper, {
        ...wrapperProps,
        children: [
            Boolean(label) && /*#__PURE__*/ _jsx(Legend, {
                as: "legend",
                children: label
            }),
            children,
            Boolean(errorMessage) && /*#__PURE__*/ _jsx(FieldFooter, {
                fieldFooterLabel: errorMessage,
                fieldFooterType: "error"
            })
        ]
    });

//# sourceMappingURL=RadioGroup.js.map